module.exports = __webpack_public_path__ + "img/volume_off_black_24dp.6bc16ece.svg";